<h5 *ngIf="attiSuggeriti && attiSuggeriti.length > 0">Atti suggeriti:</h5>
<!-- <h5 *ngIf="!attiSuggeriti || attiSuggeriti.length == 0">Nessun atto suggerito</h5> -->
<div class="row">
  <div class="col-sm-12">
    <atti-list-view
      [hasDeleteButton]="true"
      [hasAssociaButton]="true"
      [fascicolo]="fascicolo"
      [atti]="attiSuggeriti"
      [associaDisabled]="isEdit"
      (saveNewAttoEvent)="onSave($event)"
      (associaEvent)="associa($event)">
    </atti-list-view>
  </div>

  <div class="col-sm-12">
    <div class="container_tab_nav">

      <!-- Tablist -->
      <ul class="nav nav-tabs two" role="tablist" aria-label="Gestione atti">
        <li class="tab-link-nav" style="width: 50%;">
          <button
            type="button"
            role="tab"
            id="tab-lista-atti"
            class="btn-link"
            [attr.aria-selected]="!isShowForm"
            [attr.aria-controls]="'tabpanel-lista'"
            [class.active]="!isShowForm"
            [class.inactive]="isShowForm"
            (click)="onShowList()"
          >
            Lista atti inseriti
          </button>
        </li>

        <li class="tab-link-nav" style="width: 50%;">
          <button
            type="button"
            role="tab"
            id="tab-crea"
            class="btn-link"
            [attr.aria-selected]="isShowForm"
            [attr.aria-controls]="'tabpanel-crea'"
            [class.active]="isShowForm"
            [class.inactive]="!isShowForm"
            (click)="onFormAtto()"
          >
            Crea nuovo atto
          </button>
        </li>
      </ul>

      <!-- Tab panels -->
      <div class="tab-content">

        <!-- Pannello Crea nuovo atto -->
        <div
          role="tabpanel"
          id="tabpanel-crea"
          [attr.aria-labelledby]="'tab-crea'"
          [hidden]="!isShowForm"
          class="tab-pane fade"
          [class.active]="isShowForm"
          [class.in]="isShowForm"
        >
          <step-atti-form
            #formAtti
            [attoAssociato]="attoAssociato"
            [attoToEdit]="attoToEdit"
            [startAsEdit]="isEdit"
            [fascicolo]="fascicolo"
            (sendAttoEvent)="onSave($event)"
            (showListEvent)="annullaModifica()"
            (pulisciCampiEvent)="pulisciCampi()"
            (onDocumentiCaricati)="readSezione()"
          ></step-atti-form>
        </div>

        <!-- Pannello Lista atti inseriti -->
        <div
          role="tabpanel"
          id="tabpanel-lista"
          [attr.aria-labelledby]="'tab-lista-atti'"
          [hidden]="isShowForm"
          class="tab-pane fade"
          [class.active]="!isShowForm"
          [class.in]="!isShowForm"
        >
          <atti-list-view
            [hasDeleteButton]="true"
            [hasEditButton]="true"
            [fascicolo]="fascicolo"
            [atti]="atti"
            (onDropDownEvent)="onDropDownEvent($event)"
            (onDocumentEvent)="onDocumentEvent($event)"
            (deleteEvent)="deleteAtto($event)"
            (editEvent)="editAtto($event)"
          >
          </atti-list-view>
        </div>

      </div>
    </div>
  </div>
</div>

<!-- <div class="row wizard-buttons">
  <p class="col-sm-3 col-xs-6">
    <button type="button" class="btn btn-outline-secondary btn-block" (click)="reset()">Reset</button>
  </p>
  <p class="col-sm-3 col-xs-6 col-sm-offset-6">
    <button type='button' class='btn btn-primary btn-block' (click)="salva()">
      Salva
    </button>
  </p>
</div> -->
<div #bottom></div>

<div [attr.id]="'docAddModalAtti'" style="width: 100%;height: 100vh;margin: 0px;"
	doc_add_modal #docAddModalAtti [fascicolo]="fascicolo"
	(onReturn)="closeModalDocumentAndReadSezione()">
</div>

<div doc_version_update_modal  #docVersionUpdateModalAtti [attr.id]="'docVersionUpdateModalAtti'" [fascicolo]="fascicolo" (onReturn)="closeModalDocumentAndReadSezione()" style="width: 80%;"></div>

<div doc_version_history_modal #docVersionHistoryAtti [tipoPratica]="fascicolo?.praticaBase?.tipoPratica.id" [attr.id]="'docVersionHistoryAtti'"></div>


<div modale_aggiungi_scadenza_auto [attr.id]="'attiScadenzaAutoAddModal'" (onReturn)="closeModalDocumentAndReadSezione()" [isAtto]="true"
    #attiScadenzaAutoAddModal></div>
